import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import CustomPagination from '../../shared/utils/CustomPagination';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import { useDialog } from '../../shared/hook/useDialog';
import { useClustersUnderCooridinator, useTranerUnderCoorList } from '../../assets/api/useAdminApi';
import CustomDivider from '../../shared/utils/CustomDivider';
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import SelectBoxField from '../../shared/components/formfields/SelectBoxField';
import ClusterListTable from './ClusterListTable';


const CoOrdinatorListTable = ({ coOrdinatorRows, isLoading = false }) => {
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
  const [paginationModelApartment, setPaginationModelApartment] = useState({ page: 0, pageSize: 10 });
  const { open, handleClickOpen, handleClose } = useDialog();
  const [selectedRow, setSelectedRow] = useState("")
  const { data: apartmentList, isLoading: isApartmentLoading } = useTranerUnderCoorList(selectedRow.id)
  const { data: clusterList, isLoading: isClusterLoading } = useClustersUnderCooridinator({ coordinator_id: selectedRow.id })
  const ClusterRow = clusterList?.map((item, index) => ({
    sr_no: index + 1,
    ...item
  })) || [];
  const ViewCoOrdinator = (row) => {
    handleClickOpen()
    setSelectedRow(row)
  };
  const coOrdinatorColumns = [
    {
      field: "sr_no",
      headerName: "Sr No",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

    },
    {
      field: "firstname",
      headerName: "Co-ordinator Name",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value} {params.row.lastname}</Typography>,
    },
    {
      field: "mobile",
      headerName: "Mobile Number",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "email",
      headerName: "E-Mail ID",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "reporting_to_name",
      headerName: "Reporting To",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "assigned_status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
  ];
  // const ApartmentRow = apartmentList?.apartments?.map((item, index) => ({
  //   id: index + 1,
  //   ...item
  // })); 
  const [filter, setFilter] = useState({})
  const ApartmentRow = apartmentList?.apartments
    ?.filter((item) => {
      if (!filter.apartment_name) return true;
      return item.apartment_name?.toLowerCase().includes(filter.apartment_name.toLowerCase());
    })
    .map((item, index) => ({
      id: index + 1,
      sr_no: index + 1,
      ...item
    }));
  const ApartmentColumns = [
    {
      field: "sr_no",
      headerName: "Sr No",
      flex: 0.5,
      renderCell: (params) => <Typography variant="body1">{params.value}</Typography>
    },
    {
      field: "apartment_name",
      headerName: "Apartment Name",
      flex: 1.5,
      renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
    },
    {
      field: "student_count",
      headerName: "No. Of. Student",
      flex: 1.5,
      renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
    }


  ];

  const uniqueApartmentsMap = new Map();

  apartmentList?.apartments?.forEach(item => {
    if (!uniqueApartmentsMap.has(item.apartment_name)) {
      uniqueApartmentsMap.set(item.apartment_name, item);
    }
  });

  const ApartmentOptions = Array.from(uniqueApartmentsMap.values()).map(item => ({
    id: item.apartment_name,
    value: item.apartment_name,
    label: item.apartment_name,
  }));

  const handleChangeApartment = (value) => {
    setFilter({ apartment_name: value });
  };

  const handleClearApartment = () => {
    setFilter({});
  };


  return (
    <>
      {isLoading ? (
        <DataGridSkeleton rowsNum={10} />
      ) : (
        <DataGrid
          rows={coOrdinatorRows}
          columns={coOrdinatorColumns}
          pagination
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10]}
          onRowClick={(params) => ViewCoOrdinator(params.row)}
          slots={{
            pagination: () => (
              <CustomPagination
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
                totalRows={coOrdinatorRows?.length || 0}
                pageSize={paginationModel.pageSize}
              />
            ),
          }}
        />
      )}

      <MainDialogBox open={open} handleClose={() => { setFilter({}); handleClose(); }} width={"60%"}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
          <Typography variant="h3" fontWeight={"bold"}>{selectedRow.firstname} {selectedRow.lastname}</Typography>
          <Box sx={{ width: "40%" }}>
            <SelectBoxField
              label="Apartment Name"
              options={ApartmentOptions}
              isRequired={true}
              onChange={handleChangeApartment}
              ClearFunc={handleClearApartment}
              isloading={isApartmentLoading}
              value={filter?.apartment_name}
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Typography variant="body1" my={2}>Contact No: {selectedRow.mobile}</Typography>
          <Typography variant="body1" my={2}>Email: {selectedRow.email}</Typography>
          <Typography variant="body1" my={2}>Number of Apartment: {ApartmentRow?.length || 0}</Typography>
        </Box>
        <CustomDivider />
        {isApartmentLoading ? (
          <DataGridSkeleton rowsNum={5} />
        ) : (
          <DataGrid
            rows={ApartmentRow}
            columns={ApartmentColumns}
            pagination
            paginationModel={paginationModelApartment}
            onPaginationModelChange={setPaginationModelApartment}
            pageSizeOptions={[10]}
            slots={{
              pagination: () => (
                <CustomPagination
                  paginationModel={paginationModelApartment}
                  setPaginationModel={setPaginationModelApartment}
                  totalRows={ApartmentRow?.length || 0}
                  pageSize={paginationModelApartment.pageSize}
                />
              ),
            }}
          />
        )}
        <CustomDivider />
        <Typography variant="body1" my={2}>Cluster List</Typography>
        <ClusterListTable clusterRow={ClusterRow} isLoading={isClusterLoading} isEdit={false} />
      </MainDialogBox>
    </>
  )
}

export default CoOrdinatorListTable